import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";
import { toast } from "react-toastify";

export const updateJoiningDetails = createAsyncThunk('JoiningDetails/updateJoiningDetails',
  async ({ userId, payload }, { rejectWithValue }) => {
    try {
      const response = await axiosPrivate.post(`${api.updateJoiningDetails}${userId}`, payload);
      console.log('update JoiningDetails response:', response.data);
      if (response.data.success === true) {
        toast.success(response.data.reason, {
          className: "toast-success-custom",
        });
      } else {
        toast.error(response.data.reason, {
          className: "toast-error-custom",
        });
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
    }
  })

const joiningDetailsSlice = createSlice({
  name: 'JoiningDetails',
  initialState: {
    JoiningDetails: {},
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(updateJoiningDetails.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(updateJoiningDetails.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.JoiningDetails = action.payload;
        })
      .addCase(updateJoiningDetails.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        }
      )
  }
})

export default joiningDetailsSlice.reducer;